export const SCORES = [0, 1, 2, 3, 4]

export const SCORE_STRONG = 4
